<script setup lang="ts">
import { computed } from '@vue/reactivity';
import { Identifier } from 'deepslate';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSettingsStore } from '../../stores/useSettingsStore';
import ListDropdownEntry from './ListDropdownEntry.vue';

const i18n = useI18n()

const props = defineProps({
        type: String,
        entries: Object,
        selected: Object,
        icons: Function,
        colors: Function,
        group_name: String
})

defineEmits(['toggle', 'disableGroup'])
const settingsStore = useSettingsStore()


const shown = ref(true)

const sorted_entries = computed(() => props.entries?.sort((a: any, b: any) => settingsStore.collator.compare(a.localized,b.localized)))

function isGroupSelected (selected: any, group_name: any) {
    if (!selected) return false
    return [...selected].findIndex((p: string) => p.startsWith(group_name + ":")) >= 0
}

</script>

<template>
    <div class="header"
        :class="{selected: isGroupSelected(selected, group_name)}"
        @click="shown = !shown"
        @keypress="$event => {
            if ($event.key === 'Enter')
                shown = !shown
        }"
        @contextmenu="$event => {
            if (isGroupSelected(selected, group_name)){
                $emit('disableGroup')
                $event.preventDefault()   
            }
        }"
        tabindex="0"
    >
        <font-awesome-icon class="open_icon" :icon="shown ? 'fa-angle-down' : i18n.t('locale.text_direction') === 'rtl' ? 'fa-angle-left' : 'fa-angle-right'"/>
        {{ group_name }}
    </div>
    <div class="group" v-if="shown">
        <ListDropdownEntry v-for="entry in sorted_entries" :type="type" :entry="entry" :selected="selected?.has(entry.id.toString())" :icons="icons" :colors="colors" @toggle="$emit('toggle', entry.id)" />
    </div>
</template>

<style scoped>
.header {
    background-color: #f8fafc;
    color: #475569;
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    user-select: none;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: uppercase;
    border-bottom: 1px solid #e2e8f0;
}

.header:hover {
    background-color: #f1f5f9;
}

.header.selected {
    background-color: #e1f0e5;
    color: #285238;
}

.header.selected:hover {
    background-color: #d3e9d9;
}


.open_icon {
    width: 1rem;
}

</style>
